export default "__VITE_ASSET__CNRpf6fz__"